module.exports = __webpack_public_path__ + "img/nav_pay.f9385392.png";